import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";

export const requestDeleteMarketingCampaign = async (
  campaignId: string
): Promise<{ ok: boolean }> => {
  return await instance.delete(`${ApiRoutesMarketing.Campaigns}/${campaignId}`);
};
